<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_Role.id==0">Add Role </h5>
    <h5 class="card-title" *ngIf="inner_Role.id>0">Edit Role '{{inner_Role.title}}' </h5>
    <form [formGroup]="RoleForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Role Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_title().valid && get_Form_title().touched" class="form-text text-muted MyErrorRedColor">Enter the role title.</small>
        </div>
      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button"  (click)="OnSubmit()" [disabled]="!RoleForm.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br/>
    <hr/>
    <br/>

    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">

        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#navigation" role="tab"
                aria-controls="months" aria-selected="true">System Menus</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">Secretariat</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#ticket" role="tab"
                aria-controls="months" aria-selected="true">Ticket</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#deviceBehfaRepair" role="tab"
                aria-controls="months" aria-selected="true">Behfa Equipment Repair</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#deviceBehfaQRCode" role="tab"
                aria-controls="months" aria-selected="true">QR Behfa Equipment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#dataentity" role="tab"
                aria-controls="months" aria-selected="true">Register Certificate</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="navigation" role="tabpanel" aria-labelledby="months-tab">

          <ul id="MyListMenu">
            <ng-container *ngFor="let lvl1 of Data_List_Menu">
              {{lvl1.title}}
              <li *ngFor="let item of lvl1.child">
                <input type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected"
                  [ngClass]="{'Lvl2':item.parent>0}" /> {{item.title}}
              </li>
            </ng-container>
          </ul>
    

        </div>

        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <ul id="MyListMenu">
            <ng-container *ngFor="let item of Data_List_Letter_Role">
              <li>
                <input type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" class="Lvl2" />
                {{item.title}}
              </li>
            </ng-container>
          </ul>

        </div>

        <div class="tab-pane fade show" id="ticket" role="tabpanel" aria-labelledby="months-tab">
          <ul id="MyListMenu">
            <ng-container *ngFor="let item of TicketCategory_DataList">
              <li>
                <input type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" class="Lvl2" />
                {{item.title}}
              </li>
            </ng-container>
          </ul>

        </div>

        <div class="tab-pane fade show" id="deviceBehfaRepair" role="tabpanel" aria-labelledby="months-tab">
          <ul id="MyListMenu">
            <li>
              <input  type="checkbox" (change)="Data_List_Menu_Change(First_DeviceBehfa)" [checked]="First_DeviceBehfa.selected" class="Lvl2" /> Primary Reviewer
            </li>
            <li>
              <input  type="checkbox" (change)="Data_List_Menu_Change(Seond_DeviceBehfa)" [checked]="Seond_DeviceBehfa.selected" class="Lvl2" /> Secondary Reviewer
            </li>
            <li>
              <input  type="checkbox" (change)="Data_List_Menu_Change(Third_DeviceBehfa)" [checked]="Third_DeviceBehfa.selected" class="Lvl2" /> Repair Completer
            </li>
          </ul>

        </div>

        <div class="tab-pane fade show" id="deviceBehfaQRCode" role="tabpanel" aria-labelledby="months-tab">
          <ul id="MyListMenu">
            <ng-container *ngFor="let item of Data_List_DeviceBehfa_Role">
              <li>
                <input type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" class="Lvl2" />
                {{item.title}}
              </li>
            </ng-container>
          </ul>

        </div>

        <div class="tab-pane fade show" id="dataentity" role="tabpanel" aria-labelledby="months-tab">
          <ul id="MyListMenu">
            <ng-container *ngFor="let item of DataEntity_DataList">
              <li>
                <input type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" class="Lvl2" />
                {{item.title}}
              </li>
            </ng-container>
          </ul>

        </div>

      </div>
    </div>



  </div>
</div>

